import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import {
  API_POST_AGENT_CUSTOMER_DETAILS,
  API_POST_CUSTOMER_POLICIES,
} from "../../Apis/ApiEndPoints";
import { CustomAction } from "../../store/customAction";

export interface IPostCustomerPolicyRequestParams {
  customerId: string | undefined;
  carrier: string;
  system: string;
}

export const PostCustomerPolicies = createAsyncThunk(
  "agent/PostCustomerPolicy",
  async (requestParams: IPostCustomerPolicyRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_CUSTOMER_POLICIES, requestParams),
      dispatch,
      "agent/PostCustomerPolicy"
    );
    return response;
  }
);

export const PostCustomerDetails = createAsyncThunk(
  "agent/PostCustomerDetails",
  async (requestParams: IPostCustomerPolicyRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_AGENT_CUSTOMER_DETAILS, requestParams),
      dispatch,
      "agent/PostCustomerDetails"
    );
    return response;
  }
);
